export default "__VITE_ASSET__CU7hsPHx__"